import React from "react";
import Explainer from "../ExplainerModal";

const UserInformationExplainer = () => {
  return (
    <Explainer
      title="👥 User Information Explainer"
      content={
        <>
          <p>
            The <strong>User Information</strong> section provides an overview of a user, including their personal and organizational details. Administrators can manage user accounts, including activation and deactivation.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔍 User Details
          </h3>
          <ul>
            <li>📛 <strong>Name:</strong> Full name of the user.</li>
            <li>🏢 <strong>Organization:</strong> Institution or entity the user belongs to.</li>
            <li>📧 <strong>Email:</strong> Registered email address for communication.</li>
            <li>📍 <strong>Location:</strong> Country or region of operation.</li>
            <li>🔑 <strong>Access Level:</strong> User permissions within the platform.</li>
            <li>✅ <strong>Status:</strong> Indicates whether the account is active or inactive.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔧 Admin Controls
          </h3>
          <p>
            Administrators can activate or deactivate user accounts as needed to manage platform access effectively.
            This can be done using the <strong>toggle switch</strong> in the user management interface.
          </p>
        </>
      }
    />
  );
};

export default UserInformationExplainer;
